@if (isInitialNavigation) {
  <div class="loaderContainer h-screen w-full border border-transparent flex items-center justify-center text-center">
    <div class="flex flex-col items-center gap-6 overflow-hidden w-full">
      <img
        src="assets/images/techspert_logo.svg"
        class="mx-auto max-h-[240px] max-w-full w-auto h-auto"
        alt="techspert.io logo - Loading... Please wait"
      />
      <div class="spinnerTrack">
        <app-spinner size="lg" />
      </div>
    </div>
  </div>
}
<router-outlet></router-outlet>
@if (showSanta$ | async) {
  <img
    style="position: fixed; bottom: -15px; right: 100px; z-index: 999999"
    src="../../../assets/images/connect-christmas/santa-1.gif"
    [@enterAnimation]
  />
}
